import { NotificationTypeShown } from "../../contexts/authContext";
import { formattedDate, getUtcAgo } from "../../helpers/dateHelper";

export const getMsgCountFilter = (typeShown: NotificationTypeShown, username?: string) => {
    const mainFilter = `ADRESAT='${username}'`;
    const readFilter = "STATUS_WIADOMOSCI_DOM='nieodczytana'";
    return getCountFilter(typeShown, mainFilter, readFilter);
}

export const getNotifyCountFilter = (typeShown: NotificationTypeShown, userId?: string) => {
    const mainFilter = `KANAL_DOM='pwa' AND UZYTKOWNIK_ID=${prepareUserId(userId)}`;
    const readFilter = "CZY_ODCZYTANE=0";
    return getCountFilter(typeShown, mainFilter, readFilter);
}

export const getCountFilter = (typeShown: NotificationTypeShown, mainFilter: string, readFilter: string) => {
    let filter = `${mainFilter} AND ${readFilter} AND DATA_WYSLANIA IS NOT NULL`;
    if (typeShown === NotificationTypeShown.Last14Days) {
        const date = formattedDate(getUtcAgo(14));
        filter += ` AND DATA_WYSLANIA >= DATE '${date}'`;
    }
    return filter;
}

export const getMsgFilter = (typeShown: NotificationTypeShown, username?: string) => {
    const mainFilter = `ADRESAT='${username}'`;
    let readFilter = "STATUS_WIADOMOSCI_DOM='nieodczytana'";
    return getFilter(typeShown, mainFilter, readFilter, true);
}

export const getNotifyFilter = (typeShown: NotificationTypeShown, userId?: string) => {
    const mainFilter = `KANAL_DOM='pwa' AND UZYTKOWNIK_ID=${prepareUserId(userId)}`;
    const readFilter = "CZY_ODCZYTANE=0";
    return getFilter(typeShown, mainFilter, readFilter);
}

const getFilter = (typeShown: NotificationTypeShown, mainFilter: string, readFilter: string, MsgFilter?: boolean) => {
    const date = formattedDate(getUtcAgo(30));
    let importantMsgFilter = "";
    if(typeShown === NotificationTypeShown.All && MsgFilter){
        importantMsgFilter = " OR CZY_WAZNY=1"
    }
    let filter = `${mainFilter} AND (DATA_WYSLANIA > DATE '${date}' OR (DATA_WYSLANIA <= DATE '${date}' AND (${readFilter}${importantMsgFilter ? importantMsgFilter : ``})))`;
    if (typeShown === NotificationTypeShown.Unread) {
        filter += ` AND ${readFilter}`;
    } else if (typeShown === NotificationTypeShown.Last14Days) {
        const date = formattedDate(getUtcAgo(14));
        filter += ` AND DATA_WYSLANIA >= DATE '${date}'`;
    }
    return filter;
}

const prepareUserId = (userId?: string) => {
    if (userId === null || userId === undefined ||userId === "") return "-1";
    return userId;
}